module.exports = __webpack_public_path__ + "static/media/bootcampRocketseat.bac8fd95.png";